export default __webpack_public_path__ + "static/media/moonbase.3707c848.png";